<template>
    <v-container>
        <div class="titulo my-4 px-4">
            <h1 class="font-weight-bold" :class="esMovil ? 'text-h6' : 'text-h5'">
                {{ $t("estado_agenda.titulo") }}
            </h1>
        </div>
        <div>
            <div class="texto" v-html="texto">
            </div>
        </div>
        <v-container v-if="this.proyectos != null">
            <v-row v-for="(grupo, indice) in proyectos" :key="indice">
                <v-col :cols="(esMovil ? 12 : 12)" v-for="proyecto in grupo" :key="proyecto.id">
                    <v-card class="mb-4" outlined>
                        <v-row class="ma-2">
                            <v-col cols="12">
                                <p class="text-h5 mb-1 primary--text">
                                    #<span class="text-h3">{{ proyecto.id }}</span>
                                    {{ proyecto.titulo }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row v-if="mostrarPorcentajes == false" class="ma-2">
                            <v-col :cols="(esMovil ? 12 : 12)">
                                <p>
                                    {{ proyecto.descripcion }}
                                </p>
                            </v-col>
                        </v-row>
                        <v-row v-else class="ma-2">
                            <v-col :cols="(esMovil ? 12 : 9)">
                                <p>
                                    {{ proyecto.descripcion }}
                                </p>
                            </v-col>
                            <v-col :cols="(esMovil ? 12 : 3)" :class="[esMovil ? 'text-center' : 'text-right']">
                                <v-progress-circular
                                    :rotate="270"
                                    :size="120"
                                    :width="25"
                                    :value="proyecto.ejecutado"
                                    color="primary"
                                >
                                    {{ proyecto.ejecutado }}%
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                        <v-row class="ma-2">
                            <v-avatar
                                v-for="enlace in enlacesObjetivos"
                                :key="enlace.id"
                                size="60"
                                class="ma-2"
                                :class="[proyecto.objetivos.includes(enlace.id) ? '' : 'd-none', esMovil ? 'mx-auto' : ' ml-4',]"
                            >
                                <router-link :to="enlace.link">
                                    <v-img :src="enlace.icono" max-width="60"></v-img>
                                </router-link>
                            </v-avatar>
                        </v-row>
                        <v-row class="ma-2">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-header color="grey lighten-1" dark>
                                        {{ $t("estado_agenda.actuaciones") }}
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <v-simple-table class="mt-4">
                                            <template v-slot:default>
                                                <tbody>
                                                <tr
                                                    v-for="item in proyecto.actuaciones"
                                                    :key="item.id"
                                                >
                                                    <td>{{ item.descripcion }}</td>
                                                    <td v-if="mostrarPorcentajes == true">{{ item.ejecutado }}%</td>
                                                </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import MasterdataService from "@services/MasterdataService";

export default {
    name: "EstadoAgenda",
    data: () => ({
        proyectos: null,
        texto: "",
        valor: 50,
        enlacesObjetivos: [],
        enlacesAgenda2030: [],
        mostrarPorcentajes: false
    }),
    computed: {
        esMovil() {
            return this.$vuetify.breakpoint.mdAndDown;
        },
    },
    mounted() {
        MasterdataService.getEnlacesObjetivos().then((response) => {
            this.enlacesObjetivos = response.data.objetivos.map((objetivo) => ({
                ...objetivo,
                texto: this.$t(objetivo.texto),
            }));
            this.enlacesAgenda2030 = response.data.agenda_2030;
        });
        MasterdataService.getEstadoAgenda(this.$i18n.locale).then((response) => {
            let proyectos = response.data.proyectos;
            proyectos = proyectos.reduce(function (result, value, index, array) {
                if (index % 2 === 0)
                    result.push(array.slice(index, index + 2));
                return result;
            }, []);
            this.proyectos = proyectos;
            this.texto = response.data.texto;
        });
        if (this.$route.query.mostrarPorcentajes == 1) this.mostrarPorcentajes = true;
    },
};
</script>
<style scoped></style>
